import { render } from "./TripRowActionsMenu.vue?vue&type=template&id=589bc430&ts=true"
import script from "./TripRowActionsMenu.vue?vue&type=script&lang=ts"
export * from "./TripRowActionsMenu.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__